<template>
  <div>

    <dl class="grid grid-cols-1 sm:gap-5 gap-0 sm:grid-cols-2 lg:grid-cols-3 bg-primaryBg sm:bg-white rounded-md">
      <div class="relative overflow-hidden rounded-lg bg-primaryBg sm:shadow p-4">
        <dt>
          <div class="absolute rounded-md bg-primaryBtn text-primaryBg p-2">
            <svg aria-hidden="true" class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd"
            d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
            clip-rule="evenodd" />
        </svg>
          </div>
          <p class="ml-16 text-xl font-bold text-gray-900 dark:text-white">诊所信息</p>
        </dt>
        <dd class="ml-16 flex items-baseline">
          <p class="mt-1 text-base font-normal text-gray-500 dark:text-gray-400"> {{ doctorDetails.provider.cn_name }}医师<br>{{ doctorDetails.provider.cn_specialty_1 }}</p>
        </dd>
      </div>
      <div class="relative overflow-hidden rounded-lg bg-primaryBg pt-5 sm:shadow p-4">
        <dt>
          <div class="absolute rounded-md bg-primaryBtn text-primaryBg p-2">
            <svg aria-hidden="true" class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clip-rule="evenodd" />
        </svg>
          </div>
          <p class="ml-16 text-xl font-bold text-gray-900 dark:text-white"> 诊所地址:</p>
        </dt>
        <dd class="ml-16 flex items-baseline">
          <p class="mt-1 text-base font-normal text-gray-500 dark:text-gray-400">  {{ doctorDetails.facilities[0].en_full_address }}</p>
        </dd>
      </div>
      <div class="relative overflow-hidden rounded-lg bg-primaryBg sm:shadow p-4">
        <dt>
          <div class="absolute rounded-md bg-primaryBtn text-primaryBg p-2">
            <svg aria-hidden="true" class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
          fill="currentColor">
          <path
            d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
        </svg>
          </div>
          <p class="ml-16 text-xl font-bold text-gray-900 dark:text-white"> 诊所联系方式:</p>
        </dt>
        <dd class="ml-16 flex items-baseline">
          <p class="mt-1 text-base font-normal text-gray-500 dark:text-gray-400">  {{ doctorDetails.facilities[0].telephone_tracking_hys_1 ? doctorDetails.facilities[0].telephone_tracking_hys_1 : doctorDetails.facilities[0].telephone }}</p>
        </dd>
      </div>
    </dl>
  </div>
  
</template>

<script setup>
  const {
    doctorDetails
  } = useSearch()
</script>